import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {HttpService} from './http.service';
import {UtilService} from './util.service';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {environment} from '../../../environments/environment';

@Injectable()
export class HcaMemberService {
  memberInformation: any;
  memberInfo: any;
  public memberId: number | string;
  member$ = new Subject<any>();
  member = this.member$.asObservable();
  memberData$ = new Subject<any>();
  memberData = this.memberData$.asObservable();

  constructor(
    private http: HttpService,
    private utilService: UtilService
  ) {
  }

  set setMemberId(id) {
    this.memberId = id;
  }

  get getMemberId() {
    return this.memberId;
  }

  set setMemberInfo(data) {
    this.memberData$.next(data);
    this.memberInfo = data;
  }

  get getMemberInfo() {
    return this.memberInfo;
  }

  set memberDetails(data) {
    this.memberInformation = data;
  }

  get memberDetails() {
    return this.memberInformation;
  }

  setMember(member) {
    this.member$.next(member);
  }

  getByMemberInfoById(id) {
    return this.http.get(`/adminMember/getMemberInfoById/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  searchSubscriptionStatusHistory(page: number, value?: string) {
    const term = value ? encodeURIComponent(value) : '';
    return this.http.get(`/adminMember/searchSubscriptionStatusHistory?page=${page}&value=${term}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberActivityLog(memberId, page: number, size: number = 20, filters: any = {}) {
    let query = `page=${page}&size=${size}`;
    if (filters.actionGroup) {
      query += `&actionGroup=${encodeURIComponent(filters.actionGroup)}`;
    }
    if (filters.actionCode) {
      query += `&actionCode=${encodeURIComponent(filters.actionCode)}`;
    }
    if (filters.from) {
      query += `&from=${encodeURIComponent(filters.from)}`;
    }
    if (filters.to) {
      query += `&to=${encodeURIComponent(filters.to)}`;
    }
    return this.http.get(`/adminMember/getMemberActivityLog/${memberId}?${query}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberActivityLogById(id) {
    return this.http.get(`/adminMember/getMemberActivityLogById/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getBookingData(page, id) {
    return this.http.get(`/adminMember/getMemberBookings/${id}?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  checkDiscountStatus(transId) {
    return this.http.get(`/adminMember/checkDiscountStatus/${transId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberList(page, term) {
    return this.http.get(`/adminMember/getAllMembers?page=${page}&value=${term}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getConciergeMemberList(page, term) {
    return this.http.get(`/adminMember/getAllConciergeMembers?page=${page}&value=${term}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getConciergePendingItemsList(page, term) {
    return this.http.get(`/adminMember/getPendingItemsForConcierge?page=${page}&value=${term}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getSmartAgentsMemberList(page, term) {
    return this.http.get(`/adminMember/getAllSmartAgents?page=${page}&value=${term}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPhysicalCardsList(data) {
    return this.http.post(`/physicalCard/getAllCards`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberListFromFilter(data, page, value) {
    data.value = value ? value : null;
    data.pageNumber = page ? page : 0;
    return this.http.post(`/adminMember/getAllMembers`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getConciergueMemberListFromFilter(data, page, value) {
    data.value = value ? value : null;
    data.pageNumber = page ? page : 0;
    return this.http.post(`/adminMember/getAllConciergeMembers`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getSmartAgentsListFromFilter(data, page, value) {
    data.value = value ? value : null;
    data.pageNumber = page ? page : 0;
    return this.http.post(`/adminMember/getAllSmartAgents`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  conciergeDeliverTransaction(transaction_id: string, delivered: boolean) {
    let data = {
      transaction_id: transaction_id,
      delivered: delivered
    }
    return this.http.post(`/adminMember/changeDeliveredStatus`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateMembers(id, statusId, duplicatedEmailId) {
    duplicatedEmailId = duplicatedEmailId ? encodeURIComponent(duplicatedEmailId) : null;
    return this.http.get(`/adminMember/activateOrDeactivateMember/${id}/${statusId}?email=${duplicatedEmailId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  hardDeleteStay(bookingId) {
    return this.http.post(`/adminMember/hardDeleteStay/${bookingId}`, {})
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  hardDeleteMember(memberId, body: {confirmEmail: string, reason?: string}) {
    return this.http.post(`/adminMember/hardDeleteMember/${memberId}`, body)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHardDeleteAudit(page: number, size: number = 20, filters: any = {}) {
    let query = `page=${page}&size=${size}`;
    if (filters.email) {
      query += `&email=${encodeURIComponent(filters.email)}`;
    }
    if (filters.memberId) {
      query += `&memberId=${encodeURIComponent(filters.memberId)}`;
    }
    if (filters.cardCode) {
      query += `&cardCode=${encodeURIComponent(filters.cardCode)}`;
    }
    if (filters.from) {
      query += `&from=${encodeURIComponent(filters.from)}`;
    }
    if (filters.to) {
      query += `&to=${encodeURIComponent(filters.to)}`;
    }
    return this.http.get(`/adminMember/getHardDeleteAudit?${query}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHardDeleteAuditById(id) {
    return this.http.get(`/adminMember/getHardDeleteAuditById/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateBooking(id, statusId) {
    return this.http.get(`/adminMember/activateOrDeactivateBooking/${id}/${statusId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  sendEmail(id, type) {
    const url = type === 'Welcome' ? `/adminMember/sendWelcomeMailToMember/${id}` : `/adminMember/sendVerificationMailToMember/${id}`;
    return this.http.get(url)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getShoppingCartDetailsByMemberId(page, id) {
    return this.http.get(`/adminMember/getShoppingCartDetailsByMemberId/${id}?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCommentsByMemberId(page, id) {
    return this.http.get(`/adminMember/getCommentsByMemberId/${id}?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getTransactionHistory(page, id) {
    return this.http.get(`/adminMember/getTransactionHistory/${id}?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getOldTransactionHistory(page, id) {
    return this.http.get(`/adminMember/getOldTransactionHistory/${id}?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateShoppingCart(id, statusId) {
    return this.http.get(`/adminMember/activateOrDeactivateShoppingCart/${id}/${statusId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  activateOrDeactivateComment(id, statusId) {
    return this.http.get(`/adminMember/activateOrDeactivateComment/${id}/${statusId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  updateTransactionStatus(id, statusId) {
    return this.http.get(`/adminMember/updateTransactionStatus/${id}/${statusId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveAdminComments(data) {
    return this.http.post(`/adminMember/saveAdminComments`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberLogin(id, brandId) {
    return this.http.get(`/adminMember/getTokenByMemberId/${id}/?brandId=${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  updateBadgeEvents(memberId, type) {
    return this.http.get(`/adminMember/updateBadgeEvents/${memberId}?issueType=${type}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  upgradeMember(memberId) {
    return this.http.get(`/adminMember/upgradeMember/${memberId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  downgradeMember(memberId) {
    return this.http.get(`/adminMember/downgradeMember/${memberId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }


  search(terms: Observable<string>, memberId, type, isStay?) {
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => {
        if (term.length > 0) {
          return this.getTransactionSearch(term, memberId, type, isStay);
        } else {
          return Observable.of({error: 0, message: '', members: []});
        }
      });
  }

  getTransactionSearch(term, memberId, type, isStay?) {
    console.log(`search term is: ${term} for type ${type}`);
    return this.http.get(`/adminMember/${type === 'transaction' ? `getRelatedTransactions?value=${term}`
      : `getRelatedBookings?value=${term}`}&memberId=${this.memberId}&isStay=${isStay ? isStay : false}`)
      .map(res => res.json())
      .catch(() => Observable.of({error: 0, message: '', members: []}));
  }

  saveTransaction(data, isApprove) {
    return this.http.post(`/adminMember/saveTransactionHistory?isApprove=${isApprove}`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberRules() {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/adminMember/getMemberLookupData/${hotelChainId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getPhysicalCardRules() {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/physicalCard/getLookupDataForPhysicalCard/${hotelChainId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getLookupDataForMember() {
    const hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/adminMember/members/getLookupDataForMemberEdit/${hotelChainId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  createBookingStays(data) {
    return this.http.post(`/adminMember/createBookingStays`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getVoucherDownload(transaction_id) {
    const url = `/adminMember/getVoucherPdf?transaction_id=${transaction_id}`;
    return this.http.get(url)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  updateTrackingStatus(data) {
    const url = `/adminMember/updateTrackingCardStatus?status=${data.status}&cardId=${data.trackingCardId}`;
    return this.http.get(url, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getProfileChanges(memeberId, page) {
    return this.http.get(`/adminMember/getProfileChangesByMemberId/${memeberId}?page=${page}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  sendVerificationEmail(memeberId, email) {
    return this.http.get(`/adminMember/sendVerificationMailToUpdatedEmail/${memeberId}/${email}/`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  allowAccountsMerge(updatedEmailId) {
    const url = `/adminMember/allowAccountsMerge`;
    return this.updateEmailId(updatedEmailId, url);
  }

  rejectAccountsMerge(updatedEmailId) {
    const url = `/adminMember/rejectAccountsMerge`;
    return this.updateEmailId(updatedEmailId, url);
  }

  updateEmailId(updatedEmailId, url) {
    return Observable.create((observer) => {
      this.utilService.newXMLHttpRequest(observer, `${environment.BASE_API}/${url}?updatedEmailId=${updatedEmailId}`, 'POST', null);
    });
  }

  getHotelsByBrand() {
    return this.http.post(`/getAllBrandHotels`, [1])
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hca-member.service.ts